import Vue from 'vue'
import VueMq from 'vue-mq'

Vue.use(VueMq, {
  breakpoints: {
    xs: 575,
    sm: 768,
    md: 992,
    lg: 1199,
    xl: Infinity,
  },
})

declare module 'vue/types/vue' {
  export interface Vue {
    $mq: string
  }
}
